document.addEventListener("DOMContentLoaded", function () {
    // Settings for home carousels
    // Select all elements with the class "tag-home-carousel"
    var carousels = document.querySelectorAll(".tag-home-carousel");

    // Function to initialize Flickity with responsive groupCells
    function initializeHomeCarousels() {
        carousels.forEach(function (elem) {
            var groupCellsValue;

            // Check screen width and set groupCells value accordingly
            if (window.innerWidth < 575.98) {
                groupCellsValue = 2; // Show 2 slides on small screens
            } else if (window.innerWidth < 767.98) {
                groupCellsValue = 2; // Show 4 slides on medium screens
            } else if (window.innerWidth < 991.98) {
                groupCellsValue = 2; // Show 4 slides on medium screens
            } else if (window.innerWidth < 1199.98) {
                groupCellsValue = 3; // Show 4 slides on medium screens
            } else if (window.innerWidth < 1399.98) {
                groupCellsValue = 4; // Show 4 slides on medium screens
            } else {
                groupCellsValue = 5; // Show 8 slides on larger screens
            }

            // Destroy the Flickity instance if it exists
            if (elem.flickityInstance) {
                elem.flickityInstance.destroy();
            }

            // Initialize Flickity for each carousel element with responsive groupCells
            elem.flickityInstance = new Flickity(elem, {
                cellAlign: "left",
                contain: true,
                selectedAttraction: 0.2,
                friction: 0.8,
                pageDots: false,
                groupCells: groupCellsValue
            });

            // Wait until Flickity has initialized and remove aria-hidden from cells
            setTimeout(function () {
                var cells = elem.querySelectorAll(".tag-carousel-cell");
                cells.forEach(function (cell) {
                    cell.removeAttribute("aria-hidden");
                });
            }, 100);
        });
    }

    // Initialize Flickity for home carousels on page load
    initializeHomeCarousels();

    // Reinitialize Flickity for home carousels on window resize
    window.addEventListener('resize', function () {
        initializeHomeCarousels();
    });

    // prefix each alt tag to prevent redundancy with product name and help accessibility score
    const carouselContainers = document.querySelectorAll('.tag-home-carousel');
    carouselContainers.forEach(container => {
        const images = container.querySelectorAll('img');
        images.forEach((img, index) => {
            img.alt = `Photo ${index + 1} ${img.alt}`;
        });
    });
});